// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page__auth-callback[data-v-dd060c42]{margin:-1.5rem -1.25rem}.text-spinner[data-v-dd060c42]{height:100vh;display:flex;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = exports;
